import { Input } from "../../Input";
import { Modal } from "..";
import { ModalActionsEnum } from "../../../types/ModalActionsEnum";
import { Button } from "../../Button";
import { Text } from "../../Typography";
import { useState } from "react";
import useDatabase from "../../../hooks/useDatabase";

export const ModalCrud = ({ modalAction, setModalAction, onConfirm }: any) => {
  const [loading, setLoading] = useState<boolean>(false);

  const { addCollection, updateCollection, deleteCollection } = useDatabase();
  const { collection: collectionProp, item, action } = modalAction;
  const collection = collectionProp ?? item.collection;

  const isCreate = action === ModalActionsEnum.CREATE;
  const isUpdate = action === ModalActionsEnum.UPDATE;
  const isDelete = action === ModalActionsEnum.DELETE;

  const getTitle = () => {
    if (isCreate) return `Nuevo: ${collection}`;
    if (isUpdate) return `Actualizar: ${collection}`;
    if (isDelete) return `Confimación`;

    return "";
  };

  const onCloseModal = () => {
    setModalAction(null);
  };

  const onConfirmCreate = async (itemCreate: any) => {
    setLoading(true);
    const createdItem = await addCollection(collection, itemCreate);
    setLoading(false);

    onConfirm(ModalActionsEnum.CREATE, collection, createdItem);
  };

  const onConfirmUpdate = async (itemUpdate: any) => {
    setLoading(true);
    await updateCollection(collection, itemUpdate);
    setLoading(false);

    onConfirm(ModalActionsEnum.UPDATE, collection, itemUpdate);
  };

  const onConfirmDelete = async (itemDelete: any) => {
    setLoading(true);
    await deleteCollection(collection, itemDelete.id);
    setLoading(false);

    onConfirm(ModalActionsEnum.DELETE, collection, itemDelete);
  };

  return (
    <Modal open={!!modalAction} title={getTitle()} onClose={onCloseModal}>
      {isCreate && (
        <ModalCreate
          loading={loading}
          collection={collection}
          onCancel={onCloseModal}
          onConfirm={onConfirmCreate}
        />
      )}
      {isUpdate && (
        <ModalUpdate
          loading={loading}
          item={item}
          onCancel={onCloseModal}
          onConfirm={onConfirmUpdate}
        />
      )}
      {isDelete && (
        <ModalDelete
          loading={loading}
          item={item}
          onCancel={onCloseModal}
          onConfirm={onConfirmDelete}
        />
      )}
    </Modal>
  );
};

const ModalCreate = ({ loading, collection, onCancel, onConfirm }: any) => {
  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string>("");

  const onChangeName = (text: string) => {
    setName(text);
  };

  const onClickConfirm = () => {
    if (!name) {
      setError('Requerido')
    } else {
      onConfirm({
        name,
        collection,
      });
    }
  };

  return (
    <div>
      <Input
        disabled={loading}
        onChange={onChangeName}
        value={name}
        title="Nombre"
        error={error}
      />

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button loading={loading} onClick={onClickConfirm}>
          Confirmar
        </Button>
      </div>
    </div>
  );
};

const ModalUpdate = ({ loading, item, onCancel, onConfirm }: any) => {
  const [name, setName] = useState<string>(item.name);

  const onChangeName = (text: string) => {
    setName(text);
  };

  const onClickConfirm = () => {
    onConfirm({
      ...item,
      name,
    });
  };

  return (
    <div>
      <Input
        disabled={loading}
        onChange={onChangeName}
        value={name}
        title="Nombre"
      />

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button loading={loading} onClick={onClickConfirm}>
          Confirmar
        </Button>
      </div>
    </div>
  );
};

const ModalDelete = ({ loading, item, onCancel, onConfirm }: any) => {
  const onClickConfirm = () => {
    onConfirm(item);
  };

  return (
    <div>
      <Text>Desea eliminar?</Text>
      <br />
      <Text>
        {item.collection.charAt(0).toUpperCase() + item.collection.slice(1)}:{" "}
        {item.name}
      </Text>

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          loading={loading}
          red
          onClick={onClickConfirm}
        >
          Confirmar
        </Button>
      </div>
    </div>
  );
};
